export default function HeroSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0f00fec5663ddf2002b7e5a02101bd8a.jpg"
          alt="background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-[#0f0f0f]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-8 pt-32 pb-24">
        <div className="max-w-3xl">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#00d4ff] mb-6">
            iOS Application Development
          </span>
          <h1 className="text-6xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
            Modern Apps<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-[#0099cc]">
              Built for iOS
            </span><br />
            Excellence
          </h1>
          <p className="text-lg text-[#b0b0b0] leading-relaxed max-w-xl mb-10">
            BADI D.O.O. is a team of experts crafting high-performance applications for the iOS
            platform. Our products are designed to enhance user experience and strengthen the
            security of your mobile devices.
          </p>
          <div className="flex items-center gap-3">
            <div className="w-12 h-[2px] bg-[#00d4ff]"></div>
            <span className="text-[#00d4ff] text-sm tracking-widest uppercase">
              VPN &amp; Cleaner Solutions
            </span>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-[#666] text-xs tracking-widest uppercase">Scroll</span>
        <a
          href="#about"
          onClick={(e) => { e.preventDefault(); handleNav("#about"); }}
          className="w-6 h-6 flex items-center justify-center cursor-pointer"
        >
          <i className="ri-arrow-down-line text-[#00d4ff] text-xl"></i>
        </a>
      </div>
    </section>
  );
}
